import { useState, useEffect, useRef } from "react";
import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';

// import useAxios from "../../components/useAxios";
import authAxios from "../../components/authAxios";

import { Autocomplete } from "@mui/material";
import { TextField } from "@mui/material";

import { Modal, message } from 'antd';

import NumberFormat from "react-number-format";
import UserAlerts from "../../components/UserAlerts";
import useDebounce from "../../components/useDebounce";

function PaymentEdit({payment:failedPayment, isModalOpen, setIsModalOpen}) {
    const autocompleteRef = useRef(null);

    // const {response, error, fetchData}  = useAxios();
    const [error, setError] = useState('');
    const errorRef = useRef(null);
    const queryClient = useQueryClient();

    const [searchText, setSearchText] = useState('');
    const debouncedSearchText = useDebounce(searchText, 500);
    const [selectedLease, setSelectedLease] = useState(null);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    // const { data: leases, isLoading } = useQuery({
    //     queryKey: ['leases'],
    //     queryFn: async () => {
    //         const response = await authAxios.get("/rentals/leases");
    //         // const response = await authAxios.get("/rentals/lease-list");
    //         return response.data
    //     },
    // });

    const { data: leases, isLoading, isFetching } = useQuery({
        queryKey: ['leases', debouncedSearchText],
        queryFn: async () => {  
            const response = await authAxios.get("/rentals/leases", {params: {search: debouncedSearchText}});
            return response.data
        },
        enabled: !!debouncedSearchText.trim(),
        keepPreviousData: true,
        initialData: []
    });

    const [customerReference, setCustomerReference] = useState('');

    // const mutation = useMutation({
    //     mutationFn: (paymentData) => {
    //         return authAxios.put(`payments/payments/${payment.id}/`, paymentData);
    //     },
    //     onError: (error, variables, context) => {
    //         if (error.response.data.error){
    //             if (Array.isArray(error.response.data.error)) {
    //                 error.response.data.error.map((errorMessage) => (
    //                     setError(errorMessage)
    //                 ));
    //             } else {
    //                 setError(error.response.data.error); 
    //             }
    //         } else {
    //             setError(error.message); 
    //         }      
    //     },
    //     onSuccess: (result) => {
    //         queryClient.invalidateQueries(['payments', 'payment']);
    //         queryClient.refetchQueries(['payments']);
    //         queryClient.refetchQueries(['payment']);
    //         setIsModalOpen(false)
    //     },
        
    //     onSettled: () => {
    //         // setError('') //TODO: REVISIT THIS FEATURE
    //         setSelectedLease(null)
    //         setSearchText('')
    //         setCustomerReference('')
    //     }
    // })

    const mutation = useMutation({
        mutationFn: (paymentData) => {
            // return authAxios.post("payments/payments/allocate/", paymentData);
            return authAxios.post(`payments/payments/${failedPayment.id}/allocate/`, paymentData);
        },
        onError: (error, variables, context) => {
            if (error.response.data.error){
                if (Array.isArray(error.response.data.error)) {
                    error.response.data.error.map((errorMessage) => (
                        setError(errorMessage)
                    ));
                } else {
                    setError(error.response.data.error); 
                }
            } else {
                setError(error.message); 
            }      
        },
        onSuccess: (result) => {
            queryClient.invalidateQueries(['payments', 'payment']);
            queryClient.refetchQueries(['payments']);
            queryClient.refetchQueries(['payment']);
            setIsModalOpen(false)
            message.success('Payment allocated successfully');
        },
        
        onSettled: () => {
            // setError('') //TODO: REVISIT THIS FEATURE
            setSelectedLease(null)
            setSearchText('')
            setCustomerReference('')
        }
    })


    const handleSubmit = (e) => {
        e.preventDefault();

        if (failedPayment && selectedLease) {
            // const type = payment.type
            const lease = selectedLease.id
            const customer = selectedLease.customer
            const payment = failedPayment.id
            const amount = failedPayment.amount
            const date = failedPayment.date
            const paymentData = {customer, lease, payment, amount, date };
            console.log(paymentData)
            mutation.mutate(paymentData)
        } 
    }

    useEffect(()=>{
        if (error){
            errorRef.current.scrollIntoView();  
        }            
    },[error])

    useEffect(() => {
        if (isModalOpen && autocompleteRef.current) {
          autocompleteRef.current.focus();
        }
      }, [isModalOpen]);


    return(
        <>
        {isModalOpen && failedPayment && 
            <Modal 
                className="dashboard-modal" 
                title="Post Payment" 
                visible={isModalOpen} 
                open={isModalOpen} 
                onOk={handleSubmit} 
                onCancel={handleCancel}
                confirmLoading={mutation.isLoading}
            >
                <div className="dashboard-form">

                    <div ref={errorRef}>
                        <UserAlerts error={error}  />
                    </div>

                    <form noValidate autoComplete="off" onSubmit={handleSubmit}>

                        <TextField className="custom-input"
                            defaultValue = {failedPayment.reference}
                            InputProps={{ readOnly: true }}
                            label="Reference" 
                            variant="outlined" 
                            fullWidth
                        />

                        <TextField className="custom-input"
                            fullWidth
                            label="Paid By" 
                            variant="outlined" 
                            defaultValue = {failedPayment.customer_name}
                            InputProps={{ readOnly: true }}
                        />
                           <NumberFormat 
                            className="custom-input"
                            fullWidth
                            label="Amount" 
                            variant="outlined" 
                            customInput={TextField}
                            thousandSeparator={true} 
                            defaultValue = {failedPayment.amount}
                            InputProps={{ readOnly: true }}
                        />  

                        <Autocomplete
                            value={selectedLease}   
                            onClose={(e, reason) => {
                                if (reason === 'blur' && (!selectedLease || (selectedLease && searchText !== selectedLease.customer_name))) {
                                    setSearchText('');
                                    setSelectedLease(null);
                                    }
                                }}
                            
                            onChange={(event, newValue) => {
                                setSelectedLease(newValue);
                                setSearchText(newValue.customer_name)
                                setCustomerReference(newValue.customer_code);
                            }}
                            inputValue={searchText}
                            onInputChange={(event, newInput, reason) => {
                                if (reason === 'input') {
                                    setSearchText(newInput);
                                }
                                }}
                            options={leases || []} 
                            getOptionLabel={(option) => { 
                                return option ? option.name : '' }
                            } // Ensure option is not null or undefined


                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            noOptionsText={
                                searchText.trim().length < 1
                                    ? 'Please enter name or phone number'
                                    : isFetching
                                    ? 'Loading…'
                                    : 'No matches found. Please try another search term.'
                            }
                            loading={isFetching}
                            renderInput={(params) => <TextField className="custom-input" fullWidth {...params} label="Customer"  /> }
                        />

                    </form>
                </div>
            </Modal>
        }
        </>

    )

}

export default PaymentEdit;
